import _ from 'lodash';
import store from 'local-storage-fallback'
import config from '../config'

export default function getCommerceChannel(options = {}) {
  const {
    type,
    commerceChannel,
    orderMethodMandatory = true,
  } = options
  let orderMethod = {}
  try {
    orderMethod = JSON.parse(store.getItem('orderMethod'))
  } catch (error) {
    console.warn('[Error] Fail to get `key` from storage')
    orderMethod = {}
  }
  let cc = commerceChannel
  if (_.isEmpty(cc) && !_.isEmpty(type)) {
    switch (type) {
      case 'skuQuota':
        cc = config.get("api.commerceChannelForSkuQuota");
        break;
      case 'membership':
        cc = config.get("api.commerceChannelForMembership");
        break;
      default:
        break;
    }
  }
  if (_.isEmpty(cc) && orderMethodMandatory) {
    cc = _.get(orderMethod, 'commerceChannel')
  }
  if (_.isEmpty(cc)) {
    cc = config.get("api.commerceChannel")
  }
  return cc
}
